import { render } from "./PropertyIndicators.vue?vue&type=template&id=36d3d572"
import script from "./PropertyIndicators.vue?vue&type=script&lang=js"
export * from "./PropertyIndicators.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__